export default __webpack_public_path__ + "static/media/caixa_logo_chips_200.785abdc1.png";